export default __webpack_public_path__ + "static/media/gallery-wip-emitter_00.40de397e.jpg";